import React, { useEffect } from "react";
import "./CompIQSelector.css";
import * as FeatherIcon from 'react-feather';


const CompIQSelector = ({
  isSame,
  companyName,
  region,
  financialCompanyName,
  onSameChange,
  onCompanyNameChange,
  onRegionChange,
  error,
  disabled,
}) => {
  // Auto-fill when "Yes" is selected
  useEffect(() => {
    if (isSame && financialCompanyName) {
      onCompanyNameChange(financialCompanyName);
    }
  }, [isSame, financialCompanyName, onCompanyNameChange]);

  // Auto-fill region to "Global" when "Yes" is selected
  useEffect(() => {
    if (isSame) {
      onRegionChange("Global");
    }
  }, [isSame, onRegionChange]);

  const handleSameChange = (value) => {
    onSameChange(value);
    if (value) {
      onCompanyNameChange(financialCompanyName || "");
      onRegionChange("Global");
    } else {
      onCompanyNameChange("");
      onRegionChange("");
    }
  };

  return (
    <div className="compiq-selector">
      <label className="compiq-selector-label">Generate profile for *</label>

      <div className="compiq-selector-radio-group">
        <span className="compiq-selector-same-label">
          Overall company level
        </span>
        <label className="compiq-selector-radio-option">
          <input
            type="radio"
            name="compiqSame"
            checked={isSame === true}
            onChange={() => handleSameChange(true)}
            disabled={disabled}
          />
          <span>Yes</span>
        </label>
        <label className="compiq-selector-radio-option">
          <input
            type="radio"
            name="compiqSame"
            checked={isSame === false}
            onChange={() => handleSameChange(false)}
            disabled={disabled}
          />
          <span>No</span>
        </label>
      </div>

      {/* Business Unit Field */}
      <div className="compiq-selector-input-wrapper">
        <input
          type="text"
          className={`compiq-selector-input ${error ? "error" : ""}`}
          value={companyName}
          onChange={(e) => onCompanyNameChange(e.target.value)}
          placeholder={
            isSame
              ? "Auto-filled from Financial Details"
              : "select business unit/ industry..."
          }
          disabled={disabled || isSame}
        />
        {isSame && financialCompanyName && (
          <div className="compiq-selector-auto-filled">
            <FeatherIcon.Check className='comp_icon' width={"14px"} /> Auto-filled from Financial Details
          </div>
        )}
      </div>

      {/* Region Field */}
      <div className="compiq-selector-input-wrapper">
        <input
          type="text"
          className={`compiq-selector-input ${error ? "error" : ""}`}
          value={region || ""}
          onChange={(e) => onRegionChange(e.target.value)}
          placeholder={isSame ? "Global" : "select region/ country..."}
          disabled={disabled || isSame}
        />
        {isSame && (
          <div className="compiq-selector-auto-filled">
            <FeatherIcon.Check className='comp_icon' width={"14px"} /> Region set to Global
          </div>
        )}
      </div>

      {error && <div className="compiq-selector-error">{error}</div>}
    </div>
  );
};

export default CompIQSelector;
